(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["legal-ui"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      const ui = document.querySelector('[data-legal-ui]');
      const showPrefs = () => {
        try {
          if (window.privacyBanner && window.privacyBanner.showPreferences) {
            window.privacyBanner.showPreferences();
            return true;
          }
        } catch (e) {}
        return false;
      };
      document.addEventListener('click', (e) => {
        const a = e.target.closest('a[href*="shopifyReshowConsentBanner"], [data-cookie-prefs]');
        if (!a) return;
        if (showPrefs()) e.preventDefault();
      });

      const box = document.querySelector('.shopify-policy__container');
      if (!box || !ui || box.dataset.ready) return;
      box.dataset.ready = '1';
      const head = box.querySelector('.shopify-policy__title');
      const body = box.querySelector('.shopify-policy__body');
      if (!head || !body) return;

      const h1 = head.querySelector('h1');
      if (h1) {
        const parts = ['Datenschutz', 'Widerrufs', 'Rückerstattungs', 'Geschäfts', 'Versand', 'Kontakt', 'Nutzungs', 'Impressum'];
        let t = h1.textContent;
        parts.forEach((p) => {
          t = t.replace(new RegExp('(' + p + ')(?=[a-zäöü])', 'g'), '$1\u00AD');
        });
        h1.textContent = t;
      }

      const kicker = document.createElement('p');
      kicker.className = 'm-legal__kicker';
      kicker.textContent = ui.dataset.kicker || '';
      head.prepend(kicker);

      const first = body.querySelector('.rte p');
      if (first && /^(Letzte|Zuletzt|Last)/i.test(first.textContent.trim())) {
        const date = document.createElement('p');
        date.className = 'm-legal__date';
        date.textContent = first.textContent.trim();
        head.appendChild(date);
        first.classList.add('m-legal__moved');
        first.hidden = true;
      }

      const hs = [...body.querySelectorAll('h2')];
      if (hs.length > 1) {
        const det = document.createElement('details');
        det.className = 'm-legal__toc';
        if (matchMedia('(min-width: 861px)').matches) det.open = true;
        const sum = document.createElement('summary');
        sum.textContent = ui.dataset.toc || '';
        const ol = document.createElement('ol');
        const links = hs.map((h, i) => {
          if (!h.id) h.id = 'abschnitt-' + (i + 1);
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = '#' + h.id;
          a.textContent = h.textContent.trim();
          li.appendChild(a);
          ol.appendChild(li);
          return a;
        });
        det.append(sum, ol);
        head.appendChild(det);
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver(
            (entries) => {
              entries.forEach((en) => {
                if (!en.isIntersecting) return;
                const i = hs.indexOf(en.target);
                links.forEach((l, k) => l.setAttribute('aria-current', String(k === i)));
              });
            },
            { rootMargin: '-20% 0px -70% 0px' }
          );
          hs.forEach((h) => io.observe(h));
        }
      }

      if (window.privacyBanner || /privacy/i.test(location.pathname)) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'm-legal__cookies';
        btn.textContent = ui.dataset.cookies || '';
        btn.setAttribute('data-cookie-prefs', '');
        head.appendChild(btn);
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
  } catch(e) { console.error(e); }
})();

})();
